
import React from "react";
import { Link } from "react-router-dom";
import { ChevronDownIcon, PhoneIcon } from "lucide-react";

const MobileMenu = ({ mobileMenuOpen, mobileDropdowns, toggleMobileDropdown, setMobileMenuOpen, navItems }) => {
  if (!mobileMenuOpen) return null;

  const handleLinkClick = (e, to) => {
    // If it's not an anchor link, scroll to top
    if (!to.includes('#')) {
      window.scrollTo(0, 0);
    }
    setMobileMenuOpen(false);
  };

  return (
    <div className="md:hidden bg-white text-black">
      <div className="container mx-auto">
        <ul className="space-y-2 font-alatsi py-4">
          <li className="px-4 py-2 border-b border-gray-100">
            <span className="flex items-center text-sm font-bold text-black">
              <PhoneIcon className="h-4 w-4 mr-2" />
              720-298-9505
            </span>
          </li>
          {navItems.map((item) => (
            <li key={item.title}>
              {item.children ? (
                <div>
                  <button
                    className="w-full text-left py-2 px-4 hover:bg-orange-100 hover:text-orange-600 transition-colors duration-200 font-bold flex justify-between items-center"
                    onClick={() => toggleMobileDropdown(item.title)}
                  >
                    {item.title}
                    <ChevronDownIcon className={`h-4 w-4 transition-transform ${mobileDropdowns[item.title] ? 'rotate-180' : ''}`} />
                  </button>
                  {mobileDropdowns[item.title] && (
                    <ul className="pl-4">
                      {item.children.map((child) => (
                        <li key={child.title}>
                          <Link
                            to={child.to}
                            className="block py-2 px-4 hover:bg-orange-100 hover:text-orange-600 transition-colors duration-200"
                            onClick={(e) => handleLinkClick(e, child.to)}
                          >
                            {child.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ) : (
                <Link
                  to={item.to}
                  className="block py-2 px-4 hover:bg-orange-100 hover:text-orange-600 transition-colors duration-200 font-bold"
                  onClick={(e) => handleLinkClick(e, item.to)}
                >
                  {item.title}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MobileMenu;
